import { Component, OnInit, Input } from '@angular/core';
import { HttpClientService } from 'src/app/service/http-client.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Phongban } from 'src/app/model/Phongban';

@Component({
  selector: 'app-cbphongban',
  templateUrl: './cbphongban.component.html',
  styleUrls: ['./cbphongban.component.scss']
})
export class CbphongbanComponent implements OnInit {

  phongbans: Array<any>;
//  phongbans1: Array<Phongban>;
   
  @Input()
  dsitem: Array<any>;
  @Input()
  key: string;
  @Input()
  value: string;
  @Input()
  cbtitle: string;

  constructor(private httpClientService: HttpClientService,
    private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    //this.refreshData();
   // console.log(this.dsitem);
    //this.phongbans = this.dsitem;
  }

  refreshData() {
    this.httpClientService.getPhongban().subscribe(
      response => this.handleSuccessfulResponse(response),
    );

    // this.activatedRoute.queryParams.subscribe(
    //   (params) => {
    //     const id = params['id'];      
    //     this.action = params['action'];
    //     if (id) {
    //       this.selectedPB = this.phongbans.find(pb => {
    //         return pb.id === +id;
    //       });
    //     }
    //   }
    // );
  }
  handleSuccessfulResponse(response) {
    this.phongbans = response;
    
  /*    this.phongbans = new Array<Phongban>();
   
    this.phongbans1 = response;
    for (const pb of this.phongbans1) {
    
      const pb2 = new Phongban();
      pb2.id = pb.id;
      pb2.kyhieu = pb.kyhieu;
      pb2.tenphong = pb.tenphong;
      pb2.ghichu = pb.ghichu;
      pb2.hieuluc = pb.hieuluc;    
      this.phongbans.push(pb2);
    } 
    */
  } 
  
}
